/**
 * Returns the device's current GPS position as a Promise.
 * Resolves to { latitude, longitude } or { latitude: null, longitude: null }
 * if the browser does not support geolocation or the user denies permission.
 * Never rejects — callers don't need to handle errors.
 */
export const getCurrentPosition = () =>
	new Promise((resolve) => {
		if (!navigator.geolocation) {
			resolve({ latitude: null, longitude: null });
			return;
		}
		navigator.geolocation.getCurrentPosition(
			({ coords }) => resolve({ latitude: coords.latitude, longitude: coords.longitude }),
			() => resolve({ latitude: null, longitude: null }),
			{ enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
		);
	});
